import { render, staticRenderFns } from "./ZonaAmortecimentoUnidadeConservacao.vue?vue&type=template&id=7ac26f50&lang=pug"
import script from "./ZonaAmortecimentoUnidadeConservacao.vue?vue&type=script&lang=js"
export * from "./ZonaAmortecimentoUnidadeConservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports